/* eslint-disable no-console */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Keycloak from 'keycloak-js'
import axios from 'axios'

import App from './App'

import lunchConfig from './config.js'

Vue.use(VueRouter);

const routes = lunchConfig.routes;
const router = new VueRouter({
    routes
});

let keycloak = Keycloak(lunchConfig.keycloakOptions);
let token = "";

router.beforeEach(async function guard(to, from, next) {
    if (to.path === '/' && keycloak.hasRealmRole("eater"))
        next();
    else if (to.path === '/summary' && keycloak.hasRealmRole("eater"))
        next();
    else if (to.path === "/logout")
        next();
    else if (to.path === '/accounting' && keycloak.hasRealmRole("accounting"))
        next();
    else if (to.path === '/administration' && keycloak.hasRealmRole("admin"))
        next();
    else
        next(false);
});

axios.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ` + token;
    return config;
}, error => {
    return Promise.reject(error)
});

keycloak.init({onLoad: lunchConfig.keycloakOptions.onLoad, checkLoginIframe: false}).success((auth) => {
    if (!auth) {
        window.location.reload();
    }
    //console.log("xxxxxxxxxxxx",keycloak);
    token = keycloak.token;
    localStorage.setItem("vue-user-name", keycloak.tokenParsed.name);
    if (keycloak.tokenParsed.LDAP_ID)
        localStorage.setItem("vue-user-id", keycloak.tokenParsed.LDAP_ID);
    else
        localStorage.setItem("vue-user-id", keycloak.subject); 
    localStorage.setItem("keycloak-logout-url", keycloak.createLogoutUrl(lunchConfig.relogRedirect));
    localStorage.setItem("keycloak-is-admin", keycloak.hasRealmRole("admin").toString());
    localStorage.setItem("keycloak-is-accounting", keycloak.hasRealmRole("accounting").toString());

    console.log(localStorage.getItem("keycloak-logout-url"));

    setInterval(() => {
        keycloak.updateToken(70).success((refreshed) => {
            if (refreshed) {
                token = keycloak.token;
            }
        }).error(() => {
            Vue.log.error('Failed to refresh token');
        });

    }, 60000);

    new Vue({
        router,
        render: h => h(App)
    }).$mount('#app');
}).error(() => {
    console.log("Authenticated Failed");
});


